// ==============API OF ĹOGIN USER ===============================
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE'

// ==============API OF COMPANY POST==============================
export const USER_SIGNUP_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_SIGNUP_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_SIGNUP_FAILURE = 'USER_LOGIN_FAILURE'

// ==============API OF USER FETCHING INITLA DATA==============================
export const USER_FETCHING_INITIAL_DATA= 'user is fetching initial data'
export const USER_FETCHED_INITIAL_DATA_SUCCESS= 'user fetched initial data sucessfully'
export const USER_FETCHED_INITIAL_DATA_FAILURE= 'user fetched initial data failed'

// ==============API OF USER FETCHING INITLA DATA==============================
export const USER_LOGOUT= 'USER_LOGOUT';




// ======================== USER LOGIN ============================
export function userLoginRequest(){
    return{
        type: USER_LOGIN_REQUEST,
        isFetching: true
    }
}
export function userLoginSuccess(id, token){
    return{
        type: USER_LOGIN_SUCCESS,
        id: id,
        token: token,
        isFetching: false
    }
}
export function userLoginFailure(error){
    return{
        type: USER_LOGIN_FAILURE,
        error: error,
        isFetching: false
    }
}
// ======================== USER SIGNUP ===========================
export function userSignupRequest(){
    return{
        type: USER_SIGNUP_REQUEST,
        isFetching: true
    }
}
export function userSignupSuccess(id, token){
    return{
        type: USER_SIGNUP_SUCCESS,
        isFetching: false
    }
}
export function userSignupFailure(error){
    return{
        type: USER_SIGNUP_FAILURE,
        error: error,
        isFetching: false
    }
}
// ======================== USER FETCHING INITAL DATA===========================
export function userFetchingInitialData(){
    return {
        type: USER_FETCHING_INITIAL_DATA
    }
}
export function userFetchedInitialDataSuccess(token){
    return {
        type: USER_FETCHED_INITIAL_DATA_SUCCESS,
        payload: {token}
    }
}
export function userFetchedInitialDataFailed(){
    return {
        type: USER_FETCHED_INITIAL_DATA_FAILURE
    }
}
//========================== USER SEARCH =====================================
export const USER_FETCHING_SEARCH_RESULTS = 'user fetching search results'
export function userFetchingSearchResults() {
    //isFetching: true
    return {
        type: USER_FETCHING_SEARCH_RESULTS,
    }
}

export const USER_FETCHING_SEARCH_RESULTS_SUCCESS = 'user fetching search results success'
export function userFetchingSearchResultsSuccess(results) {
    return {
        type: USER_FETCHING_SEARCH_RESULTS_SUCCESS,
        results: results
    }
}

// ======================== USER LOGOUT===========================
/**
 * Only need this in actions and model, to send the action type to the rootreducer to reset
 * redux state.
*/
export function userLogout(){
    return {
        type: USER_LOGOUT
    }
}


// ==================== NOTIFICATION (WEB AND SOUND)==============

export const USER_SOUND_ON = 'USER_SOUND_ON'
export function soundOn() {
    return {
        type: USER_SOUND_ON
    }
}

export const USER_SOUND_OFF = 'USER_SOUND_OFF'
export function soundOff() {
    return {
        type: USER_SOUND_OFF
    }
}

export const USER_WEB_NOTIFICATION_ON = 'USER_WEB_NOTIFICATION_ON'
export function webNotificationOn() {
    return {
        type: USER_WEB_NOTIFICATION_ON
    }
}

export const USER_WEB_NOTIFICATION_OFF = 'USER_WEB_NOTIFICATION_OFF'
export function webNotificationOff() {
    return {
        type: USER_WEB_NOTIFICATION_OFF
    }
}

export const USER_NOTIFY_ADD = 'USER_NOTIFY_ADD'
export function notifyAdd(notificationType) {
    return {
        type: USER_NOTIFY_ADD,
        notificationType: notificationType
    }
}

export const USER_NOTIFY_REMOVE = 'USER_NOTIFY_REMOVE'
export function notifyRemove(notificationType) {
    return {
        type: USER_NOTIFY_REMOVE,
        notificationType: notificationType
    }
}



// WEBPACK FOOTER //
// src/model/User/actions.js